export const sideOptions = ['customer', 'merchant'];
export const possibleSides = ['customer', 'merchant'];
export const envOptions = ['development', 'staging', 'production'];
export const possibleEnvs = ['development', 'staging', 'production'];
export const lngOptions = ['de', 'en'];
export const possibleLngs = { de: 'Deutsch', en: 'English' };
//# sourceMappingURL=manifest.js.map